// Copyright (c) 2020-2023 dātma, inc™
// Copyright (c) 2023 datma, inc.
//
// Unauthorized copying of this file, via any medium is strictly prohibited
// Proprietary and confidential

export const getPatientToolScrollY = (parentDiv) => parentDiv.children[0].firstElementChild.scrollTop

export const setPatientToolScrollY = (parentDiv, scrollTop) => {
  setTimeout(() => {
    parentDiv.children[0].firstElementChild.scrollTop = scrollTop
  }, 50)
}
